import * as React from 'react';

import { breakpoints } from '@notino/react-styleguide';
import { ProductIdType } from '@notino/shared/definitions/types';

import { styled } from '@linaria/react';

import messages from '../../messages';
import { ProductsSection } from '../ProductsSection';
import {
  LIST_LABEL,
  MIN_SPONSORED_PRODUCTS,
} from '../SponsoredAdsProducts/constants';

import { useProductDetailAds } from './useProductDetailAds';
import { useSponsoredAdsTracking } from './useSponsoredAdsTracking';

const Wrap = styled.div`
  margin-bottom: 2rem;
  @media (min-width: ${breakpoints.lg}) {
    margin-bottom: 4rem;
  }
`;

export const SponsoredAdsProductsRma: React.FC = React.memo(() => {
  const {
    gateRef,
    inView,
    loading,
    carousel,
    provider,
    occurrences,
    cappedOccurrences,
    sponsoredProductIds,
    sponsoredProducts,
  } = useProductDetailAds();

  const { viewRef, handlers } = useSponsoredAdsTracking({
    carousel,
    provider,
    occurrences,
    cappedOccurrences,
  });

  if (
    inView &&
    !loading &&
    sponsoredProductIds.length < MIN_SPONSORED_PRODUCTS
  ) {
    return null;
  }

  return (
    <div ref={gateRef} data-testid="sponsored-ads-products-rma-wrapper">
      {inView && (
        <Wrap ref={viewRef}>
          <ProductsSection
            productIds={sponsoredProductIds}
            products={sponsoredProducts}
            idType={ProductIdType.Catalog}
            productIdsLoading={loading}
            titleMessage={messages.sponsoredProducts}
            titleId="pdSponsoredAdsProducts"
            containerId="pd-sponsored-ads-products-header"
            listLabel={LIST_LABEL}
            withDivider={false}
            trackProductClick={true}
            trackProductImpression={true}
            isSponsored={true}
            {...handlers}
          />
        </Wrap>
      )}
    </div>
  );
});
